/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Money_SessionInputs */

const en_features_money_session = /** @type {(inputs: Features_Money_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€40`)
};

const pl_features_money_session = /** @type {(inputs: Features_Money_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`150 zł`)
};

/**
* | output |
* | --- |
* | "€40" |
*
* @param {Features_Money_SessionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_money_session = /** @type {((inputs?: Features_Money_SessionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Money_SessionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_money_session(inputs)
	return en_features_money_session(inputs)
});